<template>
  <div class="pt">
    <div class="title-container">
      <h3>Materiaalkeuze</h3>
      <close-button class="close-button" @click="$emit('close')"></close-button>
    </div>
    <div class="pt-container">
      <div class="paper-type-btn-holder">
        <button
          class="option-button"
          @click="$emit('remove')"
          :class="{ active: !paperType }"
        >
          Standaard
        </button>
        <button
          class="option-button"
          v-for="type in paperTypes"
          :key="type"
          @click="$emit('setPaperType', type)"
          :class="{ active: paperType == type }"
        >
          {{ type }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['paperType', 'paperTypes']
}
</script>

<style lang="scss" scoped>
.pt {
  //  overflow: hidden;
  height: 100%;
}
.paper-type-btn-holder {
  //margin-bottom: -15px;
  //margin-left: -5px;
  //margin-right: -13px;
  //max-height: 523px;
  //overflow-x: hidden;
  //overflow-y: auto;

  button {
    margin: 9px 0;
    display: block;
    max-width: 218px;
  }
}

.pt-container {
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100% - 27px);
  margin: 0 -15px 0 0;
}
</style>
